var map = {
	"./all.png": 15069,
	"./bruiser.png": 15228,
	"./healer.png": 59441,
	"./melee-assassin.png": 6380,
	"./ranged-assassin.png": 95933,
	"./support.png": 79781,
	"./tank.png": 48362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18508;